/* Shared compact history header; background matches the home feature band. */
.traceability-panel.traceability-panel {
  display: block;
  padding: 0;
  border-radius: 4px;
}

.traceability-panel > .traceability-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  min-height: 42px;
  padding: 6px 12px;
  border-radius: 4px;
  background: #191613;
  color: white;
}

.traceability-panel > :empty {
  display: none;
}

.traceability-panel > :not(.traceability-banner):not(:empty) {
  margin: 8px 12px 12px;
}

.traceability-panel .traceability-heading {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 7px;
}

.traceability-panel .traceability-copy {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  min-width: 0;
  gap: 2px 12px;
}

.traceability-panel .traceability-copy > p {
  margin: 0;
  color: #dde5e8;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.traceability-panel .traceability-copy > :is(h2, h3) {
  margin: 0;
  color: white;
  font-size: 0.98rem;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.02em;
}

.traceability-panel .traceability-icon {
  display: inline-flex;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background: var(--color-slate-900);
  color: white;
  box-shadow: none;
}

.traceability-panel .traceability-icon > svg {
  width: 15px;
  height: 15px;
}

.traceability-panel .traceability-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;
  gap: 7px;
  color: #dde5e8;
  font-size: 10.5px;
}

.traceability-panel .traceability-banner button {
  min-height: 28px;
  height: auto;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 10.5px;
  line-height: 1.25;
}

.traceability-panel .traceability-banner .traceability-toggle {
  flex-shrink: 0;
  width: 25px;
  padding: 0;
}

.traceability-panel .traceability-actions > span {
  border-radius: 4px;
}
